import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpeaker = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" }),
		/* @__PURE__ */ _jsx("path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07" }),
		/* @__PURE__ */ _jsx("path", { d: "M18.7 5.3a9 9 0 0 1 0 13.4" })
	]
});
export default SvgSpeaker;
